var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"big-title",attrs:{"tabindex":"0"}},[_vm._v("genericUser")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }